import React from 'react'
import PropTypes from 'prop-types'
import { classNames } from '@zambezi/sdk/common'

/**
 * @param {import('./interfaces').BodyProps} props
 * @returns {JSX.Element}
 */
function Body ({ id, ...rest }) {
  const classNameProp = {
    className: Body.getClassName(rest)
  }

  const bodyProps = {
    ...rest,
    role: 'region',
    open: undefined,
    withPadding: undefined
  }

  return (
    <dd id={id} {...classNameProp}>
      <div {...bodyProps} />
    </dd>
  )
}

/**
 * @param {import('./interfaces').BodyProps} props
 * @returns {string}
 */
Body.getClassName = props =>
  classNames(
    'zb-accordion-content',
    {
      'zb-accordion-is-open': props.open,
      'zb-accordion-no-spacing': !props.withPadding
    },
    props.className
  )

Body.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool,
  withPadding: PropTypes.bool,
  className: PropTypes.string
}

export default Body
